import React, {useEffect} from 'react';
import {connect} from 'react-redux';

import SaleFooter from '../SaleFooter/SaleFooter';

import {goToPage, reportAnalytics, setSelectedInternetPackage} from '../saleBlockSlice';
import InternetPackagesHolder from '../InternetPackage/InternetPackagesHolder';

const BezeqFiberProductsPage = (props) => {
  let flowType = props.flowType;

  useEffect(() => {
    //let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    //props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'visibility_4', eventLabel: eventLabel});
  }, []);

  //page params
  let isDisplayFooter = false;
  let btnText = '';
  let currentPageFunction = handleBezeqFiberProductsPageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'sale';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> {`בכתובת שהזנתם, ${props.selectedAddress.streetName} ${props.selectedAddress.home} ${props.selectedAddress.cityName}, ניתן לבחור אחת מהחבילות הבאות`} </h1>
    </div>
  );  

  let currentPageView = (
    <InternetPackagesHolder internetPackages={props.productsInfo.bezeqFiberProducts} onSelected={handleBezeqFiberProductsPageContinue} />
  );

  function handleBezeqFiberProductsPageContinue(product) {
    props.setSelectedInternetPackage(product);
    //const eventLabel = product.name;
    //props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'click_4', eventLabel: eventLabel});

    if (flowType == 'existsCustomer') {
      props.goToPage({page: 'technicianPage', percent: 36});
    } else {
      props.goToPage({page: 'technicianPage', percent: 50});
    }
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content full-width'>
        {currentPageView}
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    productsInfo: state.saleBlock.productsInfo,
    selectedAddress: state.saleBlock.selectedAddress
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setSelectedInternetPackage,
};

export default connect(mapStateToProps, mapDispatchToProps)(BezeqFiberProductsPage);
